<app-time-off-request-modal
    title="Personal Time Request"
    [visible]="visible"
    (visibleChange)="visible = $event; visibleChange.emit($event)"
    [isScreenSmall]="!!(screen.xSmallScreenChanged | async)"
    [height]="'auto'"
    [canEdit]="canEdit"
    [canApprove]="canApprove"
    [canDecline]="canDecline"
    [canWithdrawn]="canWithdrawn"
    (save)="onSave()"
    (close)="close()"
    (statusChange)="changeStatus($event)"
    [timeOffRequest]="request"
>
    @if (formData) {
        <dx-form [colCount]="12">
            <dxi-item [colSpan]="12">
                <label class="form-label">Employee*</label>
                <pictured-item-select-box
                    [value]="formData.employee.id"
                    (valueChange)="onEmployeeChange($event)"
                    [dataSource]="employeesDataSource"
                    [readOnly]="!canEditEmployee"
                ></pictured-item-select-box>
            </dxi-item>
            <dxi-item [colSpan]="12">
                <dx-date-box
                    label="Requested Date*"
                    stylingMode="filled"
                    [showClearButton]="true"
                    type="date"
                    [(value)]="formData.requestedDate"
                    [readOnly]="!canEdit"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-date-box>
            </dxi-item>
            <dxi-item [colSpan]="6">
                <dx-date-box
                    label="Start Time*"
                    stylingMode="filled"
                    [showClearButton]="true"
                    type="time"
                    dateSerializationFormat="HH:mm"
                    [(value)]="formData.requestedStartTime"
                    [readOnly]="!canEdit"
                    pickerType="list"
                    [interval]="15"
                    (onValueChanged)="onStartTimeChanged($event)"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-date-box>
            </dxi-item>
            <dxi-item [colSpan]="6">
                <dx-date-box
                    label="End Time"
                    stylingMode="filled"
                    [showClearButton]="true"
                    type="time"
                    dateSerializationFormat="HH:mm"
                    [(value)]="formData.requestedEndTime"
                    [readOnly]="!canEdit"
                    pickerType="list"
                    [interval]="15"
                    [min]="formData.requestedStartTime"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-date-box>
            </dxi-item>
            <dxi-item [colSpan]="12">
                <strong>Personal Time Requested:</strong> {{ personalTimeRequested | formatDuration }}
            </dxi-item>
            <dxi-item [colSpan]="12">
                <strong>Personal Time Available:</strong>
                @if (employeeBalance | async; as balance) {
                    @if (balance.personalTimeMinutesAvailable != undefined) {
                        {{ balance.personalTimeMinutesAvailable | formatDuration }}
                    }
                }
            </dxi-item>
            <dxi-item [colSpan]="12">
                <dx-text-area
                    label="Description*"
                    stylingMode="filled"
                    [height]="70"
                    [(value)]="formData.description"
                    [readOnly]="!canEdit"
                >
                    <dx-validator>
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-area>
            </dxi-item>
        </dx-form>
    }

</app-time-off-request-modal>
